export const links = [
  {
    enabled: true,
    title: 'Facebook Page',
    href: 'https://facebook.com/Binary-Coffee-111577483710684/',
    icon: 'fa fa-facebook-official'
  },
  {
    enabled: true,
    title: 'GitHub Community',
    href: 'https://github.com/binary-coffee-dev',
    icon: 'fa fa-github'
  },
  {
    enabled: true,
    title: 'Twitter Page',
    href: 'https://twitter.com/CoffeeBinary/',
    icon: 'fa fa-twitter'
  },
  {
    enabled: false,
    title: 'LinkedIn Page',
    href: 'https://www.linkedin.com/company/binarycoffee/',
    icon: 'fa fa-linkedin'
  },
  {
    enabled: false,
    title: 'Instagram Page',
    href: 'https://www.instagram.com/binarycoffee.dev/',
    icon: 'fa fa-instagram'
  },
  {
    enabled: false,
    title: 'BinaryCoffee Channel',
    href: 'https://www.youtube.com/channel/UCmiGV-Amt7e4plFIxKH_v_g',
    icon: 'fa fa-youtube-play'
  },
  {
    enabled: true,
    title: 'Telegram Channel',
    href: 'https://t.me/binarycoffeedev',
    icon: 'fa fa-telegram'
  }
];
